export default "__VITE_ASSET__8hJ9Kg6M__"